export const FormSamplesControlsNotUsingFormPageInfo = () => {
    return (
        <>
            You can use any controls outside a form component if you wish to keep the look and feel consistent.<br />
            For example you might want a search box which you dont need a form for.<br />
            You just need to cater for the label, value and onChange yourself.<br />
            You can also utilize other props like showError and errorMessage.
        </>
    )
}
